<template>
    <video v-if="active" id="player" v-bind:src="movie.videoUrl" autoplay controls></video>
</template>


<script>

    import {EventBus} from '../lib/EventBus';

    export default {
        props: ['movieID'],
        data: function () {
            return {
                active: true
            }
        },
        computed: {
            movie: function () {
                let movieID = this.movieID;
                let movieIndex = window._.findIndex(window.movies, function (o) {
                    return o.id == movieID;
                });
                if (movieIndex === -1) {
                    movieIndex = 0;
                }
                return window.movies[movieIndex];
            },
        },
        mounted: function () {

            let that = this;
            let player = document.getElementById("player");

            player.addEventListener('ended', function() {
                that.active = false;
                router.go(-1);
            },false);

            EventBus.$on('play', function () {
              player.play();
            });
            EventBus.$on('pause', function () {
              player.pause();
            });
            EventBus.$on('play-pause', function () {
              if (player.paused) {
                  player.play();
              } else {
                  player.pause();
              }
            });
            EventBus.$on('stop', function () {
              that.active = false;
              router.go(-1);
            });
            EventBus.$on('fwd', function () {
              player.controls = false;
              player.controls = true;
              var pos = player.currentTime + 10;
              player.currentTime = pos;

            });
            EventBus.$on('rewind', function () {
              player.controls = false;
              player.controls = true;
              var pos = player.currentTime - 10;
              if (pos < 0) {
                pos = 0;
              }
              player.currentTime = pos;
            });


            return;

            this.$nextTick(function () {
                let elem = document.getElementById("player");
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.mozRequestFullScreen) {
                    elem.mozRequestFullScreen();
                } else if (elem.webkitRequestFullscreen) {
                    elem.webkitRequestFullscreen();
                }
            })
        },
        beforeDestroy(){
            EventBus.$off('play');
            EventBus.$off('pause');
            EventBus.$off('play-pause');
            EventBus.$off('stop');
            EventBus.$off('fwd');
            EventBus.$off('rewind');

          }
    }
</script>



// WEBPACK FOOTER //
// Player.vue?0b88e3f1